// import React, { useEffect, useState, useContext } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   HiOutlineUserGroup,
//   HiOutlineUserAdd,
//   HiOutlineCheck,
//   HiOutlineX,
//   HiOutlinePaperAirplane,
//   HiOutlineChat,
//   HiOutlineSearch,
//   HiOutlineInbox,
//   HiOutlineSparkles
// } from "react-icons/hi";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { UserContext } from "../Context/usercontext";
// import { NotificationContext } from "../Context/NotificationContext";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// const ConnectionsPage = () => {
//   const [connections, setConnections] = useState([]);
//   const [receivedRequests, setReceivedRequests] = useState([]);
//   const [sentRequests, setSentRequests] = useState([]);
//   const [suggestions, setSuggestions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [sendingRequest, setSendingRequest] = useState(null);
//   const [activeTab, setActiveTab] = useState("connections");
//   const [processingId, setProcessingId] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [prevReceivedCount, setPrevReceivedCount] = useState(0);
//   const navigate = useNavigate();

//   const { user } = useContext(UserContext);
//   const { addNotification, fetchReceivedRequests, fetchSentRequests } = useContext(NotificationContext) || {};
//   const token = Cookies.get("userToken");
//   const currentUserId = user?._id;

//   useEffect(() => {
//     fetchData();
//   }, [token, currentUserId]);


//   const fetchData = async () => {
//     try {
//       // Fetch current connections
//       const connectionsRes = await axios.get(
//         `${process.env.REACT_APP_BACKEND_URL}/apis/user/getMyConnections`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       const currentConnections = connectionsRes?.data.data || [];
//       setConnections(currentConnections);

//       // Fetch received requests
//       const receivedRes = await axios.get(
//         `${process.env.REACT_APP_BACKEND_URL}/apis/user/requestPending`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setReceivedRequests(receivedRes.data.data || []);
//       console.log(receivedRequests);

//       // Fetch sent requests
//       try {
//         const sentRes = await axios.get(
//           `${process.env.REACT_APP_BACKEND_URL}/apis/user/requestsSent`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setSentRequests(sentRes.data.data || []);
//       } catch (err) {
//         console.warn("Sent requests endpoint not available");
//         setSentRequests([]);
//       }

//       // Fetch all users for suggestion
//       const usersRes = await axios.get(
//         `${process.env.REACT_APP_BACKEND_URL}/apis/user/getAllUsers`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       const allUsers = usersRes?.data.data || [];

//       // Get IDs of connections and pending requests
//       const connectionIds = currentConnections.map(c => c._id);
//       const receivedIds = receivedRes?.data.data?.map(r => r._id) || [];
//       const sentIds = sentRequests.map(s => s.receiver?._id || s.receiver);

//       // Filter out current user, existing connections, and users with pending requests
//       const filteredUsers = allUsers.filter(u =>
//         u._id !== currentUserId &&
//         !connectionIds.includes(u._id) &&
//         !receivedIds.includes(u._id) &&
//         !sentIds.includes(u._id)
//       );

//       setSuggestions(filteredUsers);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       toast.error("Failed to load connection data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const sendConnectionRequest = async (userId) => {
//     setSendingRequest(userId);
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_BACKEND_URL}/apis/user/sendRequest/${userId}`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       toast.success(res.data.message || "Connection request sent!");
//       if (addNotification) {
//         addNotification("Connection request sent successfully", "success");
//       }

//       // Remove from suggestions
//       setSuggestions(prev => prev.filter(u => u._id !== userId));

//       // Add to sent requests
//       const sentUser = suggestions.find(u => u._id === userId);
//       if (sentUser) {
//         setSentRequests(prev => [...prev, { ...sentUser, status: 'pending' }]);
//       }

//       if (fetchSentRequests) {
//         fetchSentRequests();
//       }
//     } catch (err) {
//       console.error("Error sending connection request:", err);
//       const errorMsg = err.response?.data?.message || "Failed to send request.";
//       toast.error(errorMsg);
//     } finally {
//       setSendingRequest(null);
//     }
//   };

//   const handleAcceptRequest = async (requestId) => {
//     setProcessingId(requestId);
//     try {
//       const res = await axios.put(
//         `${process.env.REACT_APP_BACKEND_URL}/apis/user/acceptRequest/${requestId}`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       toast.success(res.data.message || "Connection accepted!");

//       // Move from received to connections
//       const acceptedRequest = receivedRequests.find(r => r._id === requestId);
//       if (acceptedRequest) {
//         setConnections(prev => [...prev, acceptedRequest]);
//         setReceivedRequests(prev => prev.filter(r => r._id !== requestId));
//       }

//       if (addNotification) {
//         addNotification("Connection accepted successfully", "success");
//       }
//       if (fetchReceivedRequests) {
//         fetchReceivedRequests();
//       }
//     } catch (err) {
//       console.error("Error accepting request:", err);
//       toast.error("Failed to accept request");
//     } finally {
//       setProcessingId(null);
//     }
//   };

//   const handleRejectRequest = async (requestId) => {
//     setProcessingId(requestId);
//     try {
//       const res = await axios.put(
//         `${process.env.REACT_APP_BACKEND_URL}/apis/user/rejectRequest/${requestId}`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       toast.success(res.data.message || "Connection request declined");
//       setReceivedRequests((prev) => prev.filter((req) => req._id !== requestId));
//       if (fetchReceivedRequests) {
//         fetchReceivedRequests();
//       }
//     } catch (err) {
//       console.error("Error rejecting request:", err);
//       toast.error("Failed to decline request");
//     } finally {
//       setProcessingId(null);
//     }
//   };

//   const handleCancelSentRequest = async (requestId) => {
//     setProcessingId(requestId);
//     try {
//       const res = await axios.put(
//         `${process.env.REACT_APP_BACKEND_URL}/apis/user/cancelSentRequest/${requestId}`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       toast.success(res.data.message || "Request cancelled");

//       // Add back to suggestions
//       const cancelledRequest = sentRequests.find(r => r._id === requestId);
//       if (cancelledRequest) {
//         setSuggestions(prev => [...prev, cancelledRequest]);
//         setSentRequests(prev => prev.filter(r => r._id !== requestId));
//       }

//       if (fetchSentRequests) {
//         fetchSentRequests();
//       }
//     } catch (err) {
//       console.error("Error cancelling request:", err);
//       toast.error("Failed to cancel request");
//     } finally {
//       setProcessingId(null);
//     }
//   };

//   const isRequestSent = (userId) => {
//     return sentRequests.some((req) =>
//       req.receiver?._id === userId || req.receiver === userId
//     );
//   };

//   useEffect(() => {
//     if (!token) return;

//     const checkForNewRequests = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_BACKEND_URL}/apis/user/requestPending`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         const newRequests = res?.data.data || [];
//         if (newRequests.length > prevReceivedCount) {
//           toast.info("🎉 New connection request received!");
//         }
//         setReceivedRequests(newRequests);
//         setPrevReceivedCount(newRequests.length);
//       } catch (err) {
//         console.error("Error checking new requests:", err);
//       }
//     };

//     const interval = setInterval(checkForNewRequests, 10000);
//     return () => clearInterval(interval);
//   }, [token, prevReceivedCount]);

//   const handleChatClick = (connection) => {
//     navigate(`/chat/${connection._id}`, {
//       state: { user: connection },
//     });
//   };

//   // Filter suggestions based on search term
//   const filteredSuggestions = suggestions.filter((user) => {
//     if (!searchTerm) return true;
//     const search = searchTerm.toLowerCase();
//     return (
//       (user.fullName && user.fullName.toLowerCase().includes(search)) ||
//       (user.email && user.email.toLowerCase().includes(search)) ||
//       (user.department && user.department.toLowerCase().includes(search))
//     );
//   });

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//         delayChildren: 0.2
//       }
//     }
//   };

//   const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { duration: 0.5 }
//     }
//   };

//   const tabs = [
//     { id: "connections", label: "My Connections", count: connections.length, icon: HiOutlineUserGroup },
//     { id: "received", label: "Received", count: receivedRequests.length, icon: HiOutlineUserAdd },
//     { id: "sent", label: "Sent", count: sentRequests.length, icon: HiOutlinePaperAirplane },
//     { id: "suggestions", label: "Suggestions", icon: HiOutlineSparkles }
//   ];

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-gray-600 mx-auto mb-4"></div>
//           <p className="text-gray-600 font-medium">Loading connections...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <motion.div
//       variants={containerVariants}
//       initial="hidden"
//       animate="visible"
//       className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 py-8 px-4 sm:px-6 lg:px-8"
//     >
//       {/* Animated Background Elements - Light Gray */}
//       <div className="fixed inset-0 overflow-hidden pointer-events-none">
//         <motion.div
//           className="absolute -top-40 -right-40 w-96 h-96 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full mix-blend-multiply filter blur-3xl opacity-60"
//           animate={{
//             x: [0, 50, 0],
//             y: [0, -30, 0],
//           }}
//           transition={{
//             duration: 20,
//             repeat: Infinity,
//             repeatType: "reverse"
//           }}
//         />
//         <motion.div
//           className="absolute -bottom-40 -left-40 w-96 h-96 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full mix-blend-multiply filter blur-3xl opacity-60"
//           animate={{
//             x: [0, -50, 0],
//             y: [0, 30, 0],
//           }}
//           transition={{
//             duration: 18,
//             repeat: Infinity,
//             repeatType: "reverse"
//           }}
//         />
//       </div>

//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <motion.div variants={itemVariants} className="mb-8">
//           <h1 className="text-3xl md:text-4xl font-bold text-gray-700">
//             My Connections
//           </h1>
//           <p className="text-gray-600 mt-2">Manage your professional network and connection requests</p>
//         </motion.div>

//         {/* Tab Navigation - Light Gray */}
//         <motion.div
//           variants={itemVariants}
//           className="flex flex-wrap gap-2 mb-8 bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-2 border border-gray-200"
//         >
//           {tabs.map((tab) => {
//             const Icon = tab.icon;
//             return (
//               <button
//                 key={tab.id}
//                 onClick={() => setActiveTab(tab.id)}
//                 className={`flex-1 px-4 py-3 rounded-lg font-semibold transition-all duration-200 relative min-w-[120px] flex items-center justify-center gap-2 ${
//                   activeTab === tab.id
//                     ? "bg-gray-700 text-white shadow-md"
//                     : "text-gray-600 hover:bg-gray-100"
//                 }`}
//               >
//                 <Icon className="w-4 h-4" />
//                 <span className="hidden sm:inline">{tab.label}</span>
//                 <span className="sm:hidden">{tab.label.slice(0, 3)}</span>
//                 {tab.count !== undefined && tab.count > 0 && (
//                   <span className="bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
//                     {tab.count}
//                   </span>
//                 )}
//               </button>
//             );
//           })}
//         </motion.div>

//         {/* My Connections Section - Light Gray */}
//         {activeTab === "connections" && (
//           <motion.div
//             key="connections"
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             exit={{ opacity: 0, x: 20 }}
//             className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-200"
//           >
//             <h3 className="text-xl font-bold text-gray-700 mb-6">
//               My Connections ({connections.length})
//             </h3>

//             {connections.length > 0 ? (
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//                 {connections.map((connection, index) => (
//                   <motion.div
//                     key={connection._id}
//                     variants={itemVariants}
//                     custom={index}
//                     whileHover={{ y: -5 }}
//                     className="bg-gradient-to-br from-white to-gray-50 p-5 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 relative group"
//                   >
//                     <button
//                       onClick={() => handleChatClick(connection)}
//                       className="absolute top-3 right-3 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition"
//                     >
//                       <HiOutlineChat className="w-4 h-4 text-gray-600" />
//                     </button>

//                     <div className="flex flex-col items-center text-center">
//                       <img
//                         src={connection.image || "/assets/DefaultImage.jpg"}
//                         alt={connection.fullName}
//                         className="w-20 h-20 rounded-full object-cover border-4 border-gray-200 mb-3"
//                       />
//                       <h4 className="font-bold text-gray-800 mb-1 line-clamp-2">
//                         {connection.fullName || "Not Available"}
//                       </h4>
//                       <p className="text-sm text-gray-500 mb-2 line-clamp-1">
//                         {connection.email || "Not Available"}
//                       </p>
//                       {connection.department && (
//                         <p className="text-xs text-gray-500 mb-1">{connection.department}</p>
//                       )}
//                       {connection.college && (
//                         <p className="text-xs text-gray-500">{connection.college}</p>
//                       )}
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-12">
//                 <div className="w-20 h-20 mx-auto bg-gradient-to-r from-gray-100 to-gray-200 rounded-full flex items-center justify-center mb-4 border border-gray-200">
//                   <HiOutlineInbox className="w-10 h-10 text-gray-500" />
//                 </div>
//                 <p className="text-gray-600 text-lg mb-2">No connections yet</p>
//                 <p className="text-gray-400">Check the Suggestions tab to find people to connect with</p>
//               </div>
//             )}
//           </motion.div>
//         )}

//         {/* Received Requests Section - Light Gray */}
//         {activeTab === "received" && (
//           <motion.div
//             key="received"
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             exit={{ opacity: 0, x: 20 }}
//             className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-200"
//           >
//             <h3 className="text-xl font-bold text-gray-700 mb-6">
//               Connection Requests Received ({receivedRequests.length})
//             </h3>

//             {receivedRequests.length > 0 ? (
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {receivedRequests.map((request, index) => (
//                   <motion.div
//                     key={request._id}
//                     variants={itemVariants}
//                     custom={index}
//                     className="bg-gradient-to-br from-gray-50 to-gray-100 p-5 rounded-xl shadow-md border-l-4 border-gray-400"
//                   >
//                     <div className="flex flex-col items-center text-center">
//                       <img
//                         src={request.image || "/assets/DefaultImage.jpg"}
//                         alt={request.fullName}
//                         className="w-16 h-16 rounded-full object-cover border-4 border-gray-200 mb-3"
//                       />
//                       <h4 className="font-bold text-gray-800 mb-1">{request.fullName || "Not Available"}</h4>
//                       <p className="text-sm text-gray-600 mb-2">{request.email || "Not Available"}</p>
//                       {request.department && (
//                         <p className="text-xs text-gray-500 mb-3">{request.department}</p>
//                       )}
//                       <div className="flex gap-3 w-full mt-4">
//                         <button
//                           onClick={() => handleRejectRequest(request._id)}
//                           disabled={processingId === request._id}
//                           className="flex-1 px-3 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg text-sm font-medium transition disabled:opacity-50 flex items-center justify-center gap-1"
//                         >
//                           <HiOutlineX className="w-4 h-4" />
//                           Decline
//                         </button>
//                         <button
//                           onClick={() => handleAcceptRequest(request._id)}
//                           disabled={processingId === request._id}
//                           className="flex-1 px-3 py-2 bg-gray-700 text-white rounded-lg text-sm font-medium hover:bg-gray-800 transition disabled:opacity-50 flex items-center justify-center gap-1"
//                         >
//                           <HiOutlineCheck className="w-4 h-4" />
//                           Accept
//                         </button>
//                       </div>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-12">
//                 <p className="text-gray-500 text-lg">No pending connection requests</p>
//               </div>
//             )}
//           </motion.div>
//         )}

//         {/* Sent Requests Section - Light Gray */}
//         {activeTab === "sent" && (
//           <motion.div
//             key="sent"
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             exit={{ opacity: 0, x: 20 }}
//             className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-200"
//           >
//             <h3 className="text-xl font-bold text-gray-700 mb-6">
//               Sent Requests ({sentRequests.length})
//             </h3>

//             {sentRequests.length > 0 ? (
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {sentRequests.map((request, index) => (
//                   <motion.div
//                     key={request._id}
//                     variants={itemVariants}
//                     custom={index}
//                     className="bg-gradient-to-br from-gray-50 to-gray-100 p-5 rounded-xl shadow-md border-l-4 border-gray-400"
//                   >
//                     <div className="flex flex-col items-center text-center">
//                       <img
//                         src={request.image || "/assets/DefaultImage.jpg"}
//                         alt={request.fullName}
//                         className="w-16 h-16 rounded-full object-cover border-4 border-gray-200 mb-3"
//                       />
//                       <h4 className="font-bold text-gray-800 mb-1">{request.fullName || "Not Available"}</h4>
//                       <p className="text-sm text-gray-600 mb-2">{request.email || "Not Available"}</p>
//                       {request.department && (
//                         <p className="text-xs text-gray-500 mb-3">{request.department}</p>
//                       )}
//                       <div className="w-full mt-4">
//                         <button
//                           onClick={() => handleCancelSentRequest(request._id)}
//                           disabled={processingId === request._id}
//                           className="w-full px-3 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm font-medium transition disabled:opacity-50 flex items-center justify-center gap-1"
//                         >
//                           <HiOutlineX className="w-4 h-4" />
//                           {processingId === request._id ? "Processing..." : "Cancel Request"}
//                         </button>
//                         <p className="text-xs text-gray-500 mt-2">Pending response...</p>
//                       </div>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-12">
//                 <p className="text-gray-500 text-lg">No sent connection requests</p>
//               </div>
//             )}
//           </motion.div>
//         )}

//         {/* Suggestions Section - Light Gray */}
//         {activeTab === "suggestions" && (
//           <motion.div
//             key="suggestions"
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             exit={{ opacity: 0, x: 20 }}
//             className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-200"
//           >
//             <div className="mb-6">
//               <div className="relative">
//                 <HiOutlineSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
//                 <input
//                   type="text"
//                   placeholder="Search by name, email, or department..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-gray-300 bg-white/80 text-gray-700 placeholder-gray-400"
//                 />
//               </div>
//             </div>

//             <h3 className="text-xl font-bold text-gray-700 mb-6">
//               People You May Know ({filteredSuggestions.length})
//             </h3>

//             {filteredSuggestions.length > 0 ? (
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//                 {filteredSuggestions.map((user, index) => (
//                   <div
//                     key={user._id}
//                     className="bg-gradient-to-br from-gray-50 to-gray-100 p-5 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200"
//                   >
//                     <div className="flex flex-col items-center text-center">
//                       <img
//                         src={user.image || "/assets/DefaultImage.jpg"}
//                         alt={user.fullName || "User"}
//                         className="w-16 h-16 rounded-full object-cover border-4 border-gray-200 mb-3"
//                         onError={(e) => {
//                           e.target.src = "/assets/DefaultImage.jpg";
//                         }}
//                       />
//                       <h4 className="font-bold text-gray-800 mb-1 line-clamp-2">
//                         {user.fullName || "Not Available"}
//                       </h4>
//                       <p className="text-sm text-gray-600 mb-2 line-clamp-1">
//                         {user.email || "Not Available"}
//                       </p>
//                       {user.department && (
//                         <p className="text-xs text-gray-500 mb-1">{user.department}</p>
//                       )}
//                       {user.college && (
//                         <p className="text-xs text-gray-500 mb-3">{user.college}</p>
//                       )}
//                       <button
//                         onClick={() => sendConnectionRequest(user._id)}
//                         disabled={sendingRequest === user._id}
//                         className="w-full mt-4 px-4 py-2 bg-gray-700 text-white rounded-lg font-medium hover:bg-gray-800 transition disabled:opacity-50 flex items-center justify-center gap-2"
//                       >
//                         <HiOutlinePaperAirplane className="w-4 h-4" />
//                         {sendingRequest === user._id ? "Sending..." : "Send Request"}
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-12">
//                 <div className="w-20 h-20 mx-auto bg-gradient-to-r from-gray-100 to-gray-200 rounded-full flex items-center justify-center mb-4 border border-gray-200">
//                   <HiOutlineUserGroup className="w-10 h-10 text-gray-500" />
//                 </div>
//                 <p className="text-gray-600 text-lg mb-2">No suggestions available</p>
//                 <p className="text-gray-400">Check back later for more people to connect with</p>
//               </div>
//             )}
//           </motion.div>
//         )}
//       </div>
//     </motion.div>
//   );
// };

// export default ConnectionsPage;

import React, { useEffect, useState, useContext } from "react";
import { motion } from "framer-motion";
import {
  HiOutlineUserGroup,
  HiOutlineUserAdd,
  HiOutlineCheck,
  HiOutlineX,
  HiOutlinePaperAirplane,
  HiOutlineChat,
  HiOutlineSearch,
  HiOutlineInbox,
  HiOutlineSparkles
} from "react-icons/hi";
import axios from "axios";
import Cookies from "js-cookie";
import { UserContext } from "../Context/usercontext";
import { NotificationContext } from "../Context/NotificationContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ConnectionsPage = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { addNotification } = useContext(NotificationContext) || {};

  // Get token once
  const token = Cookies.get("userToken");

  // Core state
  const [connections, setConnections] = useState([]);
  const [receivedRequests, setReceivedRequests] = useState([]);
  const [sentRequests, setSentRequests] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  // UI state
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("received");
  const [processingId, setProcessingId] = useState(null);
  const [sendingRequest, setSendingRequest] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  // Track if data has been loaded
  const [dataLoaded, setDataLoaded] = useState(false);

  // Single source of truth for current user ID
  const currentUserId = user?._id;

  // Load data only once when user is available
  useEffect(() => {
    if (!token) {
      toast.error("Please login to view connections");
      navigate("/login");
      return;
    }

    if (!currentUserId) {
      return;
    }

    if (!dataLoaded) {
      loadAllData();
    }
  }, [currentUserId, token, dataLoaded, navigate]);

  const loadAllData = async () => {
    setLoading(true);

    try {
      const headers = { Authorization: `Bearer ${token}` };

      const [receivedRes, connectionsRes, sentRes, usersRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/apis/user/requestPending`, { headers }).catch(() => ({ data: { data: [] } })),
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/apis/user/getMyConnections`, { headers }).catch(() => ({ data: { data: [] } })),
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/apis/user/requestsSent`, { headers }).catch(() => ({ data: { data: [] } })),
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/apis/user/getAllUsers`, { headers }).catch(() => ({ data: { data: [] } }))
      ]);

      const receivedData = receivedRes.data?.data || [];
      const connectionsData = connectionsRes.data?.data || [];
      const sentData = sentRes.data?.data || [];
      const allUsers = usersRes.data?.data || [];
      
      console.log("Connections Data:", connectionsData);

      // Calculate suggestions
      const connectionIds = new Set(connectionsData.map(c => c._id));
      const receivedIds = new Set(receivedData.map(r => r._id));
      const sentIds = new Set(
        sentData.map(req => req.receiver?._id || req.receiver || req._id)
      );

      const suggestionsData = allUsers.filter(user =>
        user._id !== currentUserId &&
        !connectionIds.has(user._id) &&
        !receivedIds.has(user._id) &&
        !sentIds.has(user._id)
      );

      setConnections(connectionsData);
      setReceivedRequests(receivedData);
      setSentRequests(sentData);
      setSuggestions(suggestionsData);

      setDataLoaded(true);

    } catch (error) {
      console.error("❌ Error loading data:", error);
      toast.error("Failed to load connections data");
    } finally {
      setLoading(false);
    }
  };

  const sendConnectionRequest = async (userId) => {
    setSendingRequest(userId);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/apis/user/sendRequest/${userId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Connection request sent!");

      const user = suggestions.find(u => u._id === userId);
      if (user) {
        setSuggestions(prev => prev.filter(u => u._id !== userId));
        setSentRequests(prev => [...prev, user]);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send request");
    } finally {
      setSendingRequest(null);
    }
  };

  const handleAcceptRequest = async (requestId) => {
    setProcessingId(requestId);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/apis/user/acceptRequest/${requestId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Connection accepted!");

      const acceptedUser = receivedRequests.find(r => r._id === requestId);
      if (acceptedUser) {
        setReceivedRequests(prev => prev.filter(r => r._id !== requestId));
        setConnections(prev => [...prev, acceptedUser]);
      }
    } catch (err) {
      toast.error("Failed to accept request");
    } finally {
      setProcessingId(null);
    }
  };

  const handleRejectRequest = async (requestId) => {
    setProcessingId(requestId);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/apis/user/rejectRequest/${requestId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Request declined");
      setReceivedRequests(prev => prev.filter(r => r._id !== requestId));
    } catch (err) {
      toast.error("Failed to decline request");
    } finally {
      setProcessingId(null);
    }
  };

  const handleCancelRequest = async (requestId) => {
    setProcessingId(requestId);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/apis/user/cancelSentRequest/${requestId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Request cancelled");

      const cancelledUser = sentRequests.find(r => r._id === requestId);
      if (cancelledUser) {
        setSentRequests(prev => prev.filter(r => r._id !== requestId));
        setSuggestions(prev => [...prev, cancelledUser]);
      }
    } catch (err) {
      toast.error("Failed to cancel request");
    } finally {
      setProcessingId(null);
    }
  };

  const handleChatClick = (user) => {
    navigate(`/chat/${user._id}`, { 
      state: { 
        user: {
          ...user,
          // These flattened fields are already there!
          // Just pass the whole object
        }
      } 
    });
  };

  // Filter suggestions based on search
  const filteredSuggestions = suggestions.filter(user => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      user.fullName?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term) ||
      user.department?.toLowerCase().includes(term) ||  // ✅ Now using root department
      user.userCollegeName?.toLowerCase().includes(term)
    );
  });

  // Animation variants
  const variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  const tabs = [
    { id: "connections", label: "My Connections", count: connections.length, icon: HiOutlineUserGroup },
    { id: "received", label: "Received", count: receivedRequests.length, icon: HiOutlineUserAdd },
    { id: "sent", label: "Sent", count: sentRequests.length, icon: HiOutlinePaperAirplane },
    { id: "suggestions", label: "Suggestions", icon: HiOutlineSparkles }
  ];

  if (loading && !dataLoaded) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-gray-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading your network...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      {/* Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <motion.div
          initial="hidden"
          animate="visible"
          variants={variants}
          className="mb-8"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-gray-700">My Connections</h1>
          <p className="text-gray-600 mt-2">Manage your professional network and connection requests</p>
        </motion.div>

        {/* Tabs */}
        <motion.div
          initial="hidden"
          animate="visible"
          variants={variants}
          className="flex flex-wrap gap-2 mb-8 bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-2 border border-gray-200"
        >
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 px-4 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2 ${activeTab === tab.id
                  ? "bg-gray-700 text-white shadow-md"
                  : "text-gray-600 hover:bg-gray-100"
                }`}
            >
              <tab.icon className="w-4 h-4" />
              <span className="hidden sm:inline">{tab.label}</span>
              {tab.count > 0 && (
                <span className="bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </motion.div>

        {/* Connections Tab */}
        {activeTab === "connections" && (
          <motion.div
            initial="hidden"
            animate="visible"
            variants={variants}
            className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-200"
          >
            <h3 className="text-xl font-bold text-gray-700 mb-6">My Connections ({connections.length})</h3>

            {connections.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {connections.map(connection => (
                  <motion.div
                    key={connection._id}
                    whileHover={{ y: -5 }}
                    className="bg-gradient-to-br from-white to-gray-50 p-5 rounded-xl shadow-md border border-gray-200 relative group"
                  >
                    <button
                      onClick={() => handleChatClick(connection)}
                      className="absolute top-3 right-3 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition"
                    >
                      <HiOutlineChat className="w-4 h-4 text-gray-600" />
                    </button>

                    <div className="flex flex-col items-center text-center">
                      <img
                        src={connection.profileImage || "/assets/DefaultImage.jpg"}
                        alt={connection.fullName}
                        className="w-20 h-20 rounded-full object-cover border-4 border-gray-200 mb-3"
                        onError={(e) => e.target.src = "/assets/DefaultImage.jpg"}
                      />
                      <h4 className="font-bold text-gray-800 mb-1">{connection.fullName || "Not Available"}</h4>
                      <p className="text-sm text-gray-500 mb-2">{connection.email || "Not Available"}</p>
                      
                      
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <HiOutlineInbox className="w-20 h-20 mx-auto text-gray-400 mb-4" />
                <p className="text-gray-600 text-lg mb-2">No connections yet</p>
                <p className="text-gray-400">Check the Suggestions tab to find people to connect with</p>
              </div>
            )}
          </motion.div>
        )}

        {/* Received Tab */}
        {activeTab === "received" && (
          <motion.div
            initial="hidden"
            animate="visible"
            variants={variants}
            className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-200"
          >
            <h3 className="text-xl font-bold text-gray-700 mb-6">Connection Requests Received ({receivedRequests.length})</h3>

            {receivedRequests.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {receivedRequests.map(request => (
                  <div
                    key={request._id}
                    className="bg-gradient-to-br from-gray-50 to-gray-100 p-5 rounded-xl shadow-md border-l-4 border-amber-400"
                  >
                    <div className="flex flex-col items-center text-center">
                      <img
                        src={request.profileImage || "/assets/DefaultImage.jpg"}
                        alt={request.fullName}
                        className="w-16 h-16 rounded-full object-cover border-4 border-gray-200 mb-3"
                        onError={(e) => e.target.src = "/assets/DefaultImage.jpg"}
                      />
                      <h4 className="font-bold text-gray-800 mb-1">{request.fullName || "Not Available"}</h4>
                      <p className="text-sm text-gray-600 mb-2">{request.email || "Not Available"}</p>
                      
                      {/* Show department */}
                      <p className="text-xs text-gray-500 mb-2">
                        {request.department || ""}
                      </p>

                      <div className="flex gap-3 w-full mt-4">
                        <button
                          onClick={() => handleRejectRequest(request._id)}
                          disabled={processingId === request._id}
                          className="flex-1 px-3 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg text-sm font-medium transition disabled:opacity-50"
                        >
                          <HiOutlineX className="w-4 h-4 inline mr-1" />
                          Decline
                        </button>
                        <button
                          onClick={() => handleAcceptRequest(request._id)}
                          disabled={processingId === request._id}
                          className="flex-1 px-3 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-sm font-medium transition disabled:opacity-50"
                        >
                          <HiOutlineCheck className="w-4 h-4 inline mr-1" />
                          Accept
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <HiOutlineInbox className="w-20 h-20 mx-auto text-gray-400 mb-4" />
                <p className="text-gray-500 text-lg">No pending connection requests</p>
              </div>
            )}
          </motion.div>
        )}

        {/* Sent Tab */}
        {activeTab === "sent" && (
          <motion.div
            initial="hidden"
            animate="visible"
            variants={variants}
            className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-200"
          >
            <h3 className="text-xl font-bold text-gray-700 mb-6">Sent Requests ({sentRequests.length})</h3>

            {sentRequests.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {sentRequests.map(request => {
                  const userData = request.receiver || request;
                  return (
                    <div
                      key={request._id}
                      className="bg-gradient-to-br from-gray-50 to-gray-100 p-5 rounded-xl shadow-md border-l-4 border-orange-400"
                    >
                      <div className="flex flex-col items-center text-center">
                        <img
                          src={userData.profileImage || "/assets/DefaultImage.jpg"}
                          alt={userData.fullName}
                          className="w-16 h-16 rounded-full object-cover border-4 border-gray-200 mb-3"
                          onError={(e) => e.target.src = "/assets/DefaultImage.jpg"}
                        />
                        <h4 className="font-bold text-gray-800 mb-1">{userData.fullName || "Not Available"}</h4>
                        <p className="text-sm text-gray-600 mb-2">{userData.email || "Not Available"}</p>
                        
                        {/* Show department */}
                        <p className="text-xs text-gray-500 mb-2">
                          {userData.department || ""}
                        </p>

                        <button
                          onClick={() => handleCancelRequest(request._id)}
                          disabled={processingId === request._id}
                          className="w-full mt-4 px-3 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm font-medium transition disabled:opacity-50"
                        >
                          <HiOutlineX className="w-4 h-4 inline mr-1" />
                          {processingId === request._id ? "Processing..." : "Cancel Request"}
                        </button>
                        <p className="text-xs text-gray-500 mt-2">⏳ Pending response...</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-12">
                <HiOutlineInbox className="w-20 h-20 mx-auto text-gray-400 mb-4" />
                <p className="text-gray-500 text-lg">No sent connection requests</p>
              </div>
            )}
          </motion.div>
        )}

        {/* Suggestions Tab */}
        {activeTab === "suggestions" && (
          <motion.div
            initial="hidden"
            animate="visible"
            variants={variants}
            className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-gray-200"
          >
            <div className="mb-6">
              <div className="relative">
                <HiOutlineSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search by name, email, or department..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-gray-300"
                />
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-700 mb-6">People You May Know ({filteredSuggestions.length})</h3>

            {filteredSuggestions.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {filteredSuggestions.map(user => (
                  <div
                    key={user._id}
                    className="bg-gradient-to-br from-gray-50 to-gray-100 p-5 rounded-xl shadow-md border border-gray-200"
                  >
                    <div className="flex flex-col items-center text-center">
                      <img
                        src={user.profileImage || "/assets/DefaultImage.jpg"}
                        alt={user.fullName}
                        className="w-16 h-16 rounded-full object-cover border-4 border-gray-200 mb-3"
                        onError={(e) => e.target.src = "/assets/DefaultImage.jpg"}
                      />
                      <h4 className="font-bold text-gray-800 mb-1">{user.fullName || "Not Available"}</h4>
                      <p className="text-sm text-gray-600 mb-2">{user.email || "Not Available"}</p>
                      
                      {/* Show department */}
                      <p className="text-xs text-gray-500 mb-2">
                        {user.department || ""}
                      </p>

                      <button
                        onClick={() => sendConnectionRequest(user._id)}
                        disabled={sendingRequest === user._id}
                        className="w-full mt-4 px-4 py-2 bg-gray-700 hover:bg-gray-800 text-white rounded-lg font-medium transition disabled:opacity-50"
                      >
                        <HiOutlinePaperAirplane className="w-4 h-4 inline mr-2" />
                        {sendingRequest === user._id ? "Sending..." : "Send Request"}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <HiOutlineUserGroup className="w-20 h-20 mx-auto text-gray-400 mb-4" />
                <p className="text-gray-600 text-lg mb-2">No suggestions available</p>
              </div>
            )}
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default ConnectionsPage;